import { DRAFT_AGENCY_CHAT_PANEL_CONSTRAINTS } from '@saaga/shared/constants/draft-agency-chat.constants'
import { type ReactNode, useCallback } from 'react'

import {
  type UseDraftAgencyPreviewChatProps,
  useDraftAgencyPreviewChat,
} from '@/hooks/use-draft-agency-preview-chat.hook'
import { useIsMobile } from '@/hooks/use-mobile.hook'

import { AgencyPreviewChatDesktop } from './agency-preview-chat-desktop.atom'
import { AgencyPreviewChatMobile } from './agency-preview-chat-mobile.atom'

export interface AgencyPreviewChatPanelProps extends UseDraftAgencyPreviewChatProps {
  className?: string
}

export const AgencyPreviewChatPanel: React.FC<AgencyPreviewChatPanelProps> = ({
  agencyId,
  agencySlug,
  className,
}): ReactNode => {
  const isMobile = useIsMobile()
  const { state, handlers, conversationId } = useDraftAgencyPreviewChat({ agencyId, agencySlug })

  const handleResizeWithConstraints = useCallback(
    (deltaX: number) => {
      const newWidth = state.panelWidth - deltaX
      if (newWidth < DRAFT_AGENCY_CHAT_PANEL_CONSTRAINTS.minWidth) {
        handlers.handleClose()
        return
      }
      handlers.handleResize(deltaX)
    },
    [state.panelWidth, handlers]
  )

  if (isMobile) {
    return (
      <AgencyPreviewChatMobile
        state={state}
        handlers={handlers}
        conversationId={conversationId}
        className={className}
      />
    )
  }

  return (
    <AgencyPreviewChatDesktop
      state={state}
      handlers={handlers}
      conversationId={conversationId}
      onResize={handleResizeWithConstraints}
      className={className}
    />
  )
}

AgencyPreviewChatPanel.displayName = 'AgencyPreviewChatPanel'
